import { v4 as uuid } from "uuid";
import { isPyodideLoaded, refreshPyodideDatasetCache, simulationFromRequest, updatePythonGlobals, } from "../../";
const rebuildWrapper = (wasmlib, components, fromState) => wasmlib.start_simulation(fromState, components?.properties, components?.datasets, components?.behaviors, components?.handlers);
const runSim = async (runner) => {
    const iter = runner.wrapper?.get_iter();
    while (runner.stepsLeft > 0 && runner.running && runner.wrapper && iter) {
        const msStart = runner.devMode ? Date.now() : 0;
        const newState = await runner.wasmlib.next_state(iter);
        if (runner.devMode) {
            console.log(`State obtained in ${Date.now() - msStart}ms`);
        }
        const stop = runner.parsedSimulation?.behaviors.updateAgentCache(newState);
        runner.accumulatedSteps[runner.stepsTaken + 1] = newState;
        runner.latestState = newState;
        runner.stepsTaken += 1;
        runner.stepsLeft -= 1;
        await new Promise((resolve) => setImmediate(resolve));
        if (runner.stepHandler) {
            await runner.stepHandler(runner.stepsTaken + 1, newState);
        }
        if (stop) {
            runner.earlyStop = true;
            runner.stopMessage = stop.data;
            break;
        }
    }
    runner.running = false;
};
const initialize = async (request, runner) => {
    if (runner.wrapper) {
        runner.wrapper.free();
        runner.wrapper = null;
    }
    runner.simulationRunId = request.presetRunId ?? uuid();
    runner.stepsLeft = request.numSteps;
    runner.stepsTaken = 0;
    runner.earlyStop = false;
    runner.stopMessage = null;
    try {
        runner.parsedSimulation = await simulationFromRequest(request.manifestSrc, runner.datasetCache, request.pyodideEnabled);
    }
    catch (err) {
        if (err.message === "Cannot load pyodide") {
            runner.pyodide = "errored";
            return false;
        }
        else {
            throw err;
        }
    }
    if (runner.pyodide === "errored") {
        runner.pyodide = null;
    }
    if (isPyodideLoaded()) {
        await refreshPyodideDatasetCache(runner.datasetCache);
        updatePythonGlobals(JSON.stringify(runner.parsedSimulation.properties));
    }
    const initialState = runner.parsedSimulation.initializer.apply();
    runner.wrapper = rebuildWrapper(runner.wasmlib, runner.parsedSimulation, initialState);
    runner.latestState = runner.wrapper.initial_state();
    runner.parsedSimulation.behaviors.updateAgentCache(runner.latestState);
    runner.accumulatedSteps = { 0: runner.latestState };
    runner.parsedSimulation.behaviors.updateProperties(runner.parsedSimulation.properties);
    return true;
};
const step = async (request, runner) => {
    if (runner.earlyStop) {
        return;
    }
    runner.stepsLeft = request.numSteps;
    runner.running = true;
    await runSim(runner).catch((err) => {
        runner.runnerError = err;
    });
};
const play = (request, runner) => {
    if (runner.earlyStop) {
        return;
    }
    if (runner.simulationRunId) {
        updateComponents({ propertiesSrc: request.propertiesSrc }, runner);
        runner.stepsLeft = 100000000;
        runner.running = true;
        runSim(runner).catch((err) => {
            runner.runnerError = err;
        });
    }
};
const pause = (runner) => {
    runner.running = false;
};
const getReadySteps = async (runner) => {
    while (runner.running &&
        Object.values(runner.accumulatedSteps).length === 0 &&
        !runner.runnerError) {
        await new Promise((r) => setTimeout(r, 40));
    }
    return {
        StepsRequested: true,
    };
};
const updateComponents = (request, runner) => {
    try {
        if (runner.parsedSimulation) {
            if (request.propertiesSrc) {
                const props = JSON.parse(request.propertiesSrc);
                runner.parsedSimulation.properties = props;
                runner.parsedSimulation.behaviors.updateProperties(props);
                updatePythonGlobals(request.propertiesSrc);
            }
            runner.wrapper = rebuildWrapper(runner.wasmlib, runner.parsedSimulation, runner.latestState);
        }
    }
    catch (err) {
        runner.running = false;
        throw err;
    }
};
export const runnerActions = {
    rebuildWrapper,
    runSim,
    initialize,
    step,
    pause,
    getReadySteps,
    updateComponents,
    play,
};
//# sourceMappingURL=actions.js.map